import { useChain, useInView } from "@react-spring/web"
import { useOpacity } from "./useOpacity.hook"

export const useOpacityInView = (config?: {rootMargin?: string, once?: boolean}) => {
    const [elRef, isInView] = useInView({rootMargin: `0px 0px -200px 0px`, once: true, ...config})
    const [ spRef, style ] = useOpacity()
    useChain(isInView ? [spRef]: [])
    return [ elRef, style, isInView ] as [typeof elRef, typeof style, boolean]
}